module.exports = __webpack_public_path__ + "img/classroom2.c5953c4e.png";